// Native port of the v3 Mac auto-update dispatch pair
// (src/lib/offline/UpdateAppButton.tsx exports) — executeMethods payloads
// verbatim (drift-pinned against the live v3 functions). Delta: the v3
// download fallback passed a RAW i18n key to antd message.error — translated
// sonner toast here.
import i18n from 'i18next';
import { toast } from 'sonner';

import {
  AppType,
  checkAutoUpdateSupported,
  getAutoUpdateValues,
  getOfflineAppDownloadUrl,
} from '@/lib/offline/OfflineAppHelper';

/* eslint-disable @typescript-eslint/no-explicit-any */

export const dispatchToUpdateNativeMacApp = (
  triggerType: string,
  appType: AppType,
  appRegion: string,
  enabledFeatures: any,
  executeMethods: any,
  callbackForAutoUpdateFailOrCompletion: any
) => {
  if (appType !== 'mac') {
    return;
  }

  const isAutoUpdateEnabled = enabledFeatures.allow_auto_update_mac_app;
  const isAutoUpdateSupported = checkAutoUpdateSupported(appType, enabledFeatures);

  if (!isAutoUpdateEnabled || !isAutoUpdateSupported) {
    callbackForAutoUpdateFailOrCompletion?.(appType, appRegion, executeMethods, enabledFeatures);
    return;
  }

  const appUpdateValues = getAutoUpdateValues(triggerType, appType, enabledFeatures);

  if (!appUpdateValues) {
    return;
  }

  executeMethods(
    [
      {
        key: 'startUpdate',
        value: JSON.stringify(appUpdateValues),
        errorCallback: () =>
          callbackForAutoUpdateFailOrCompletion?.(
            appType,
            appRegion,
            executeMethods,
            enabledFeatures
          ),
      },
    ],
    {
      errorCallback: () =>
        callbackForAutoUpdateFailOrCompletion?.(
          appType,
          appRegion,
          executeMethods,
          enabledFeatures
        ),
    }
  );
};

export const dispatchToDownloadNativeMacApp = (
  appType: AppType,
  appRegion: string,
  executeMethods: any,
  enabledFeatures: any
) => {
  const downloadUrl = getOfflineAppDownloadUrl(appType, appRegion, enabledFeatures);

  if (!downloadUrl) {
    toast.error(i18n.t('CommonText.something_went_wrong_please_try_again'));
    return;
  }

  executeMethods([
    {
      key: 'openLinkInBrowser',
      value: downloadUrl,
    },
  ]);
};

/* eslint-enable @typescript-eslint/no-explicit-any */
